import React from 'react'
import IncidentsTable from './IncidentsTable'


const ValidIncidents = () => {

  const validTitle = "Valid Incidents"
  const incidentValidity=true
  
  
  return (
    <>
      <IncidentsTable incidentTitle={validTitle} incidentValidity={ incidentValidity} />
    </>
  )
}

export default ValidIncidents